import { AssetTag } from '@/feature/tags'

/**
 * The panel is far wider than a table cell, so show every tag an asset can hold rather than
 * collapsing into a "+N" count. Matches the 10-tag assignment ceiling enforced by `useTagToggle`.
 */
export const PANEL_MAX_VISIBLE_TAGS = 10

/**
 * Reconciles the tags stored on an asset against the organisation's current tag list so renamed or
 * recoloured tags render with their latest values, and tags that have since been deleted drop out.
 * Mirrors the behaviour of the assets table cell so tags look the same wherever they appear.
 */
export const resolveAssetTags = (
  assetTags: AssetTag[] | undefined,
  globalOrgTags: AssetTag[],
): AssetTag[] => {
  if (!assetTags?.length) return []

  return assetTags.reduce<AssetTag[]>((resolved, assetTag) => {
    const globalTag = globalOrgTags.find((tag) => tag.id === assetTag.id)

    if (globalTag) {
      resolved.push({ ...assetTag, name: globalTag.name, color: globalTag.color })
    }

    return resolved
  }, [])
}
